// extracted by mini-css-extract-plugin
module.exports = {"body":"ChangePayReleaseDateForm__body--jkWxJ"};